module.exports = __webpack_public_path__ + "img/qyjy1.c42a8acf.png";